import { render, staticRenderFns } from "./payMethod.vue?vue&type=template&id=b840eb50&scoped=true&"
import script from "./payMethod.vue?vue&type=script&lang=js&"
export * from "./payMethod.vue?vue&type=script&lang=js&"
import style0 from "./payMethod.vue?vue&type=style&index=0&id=b840eb50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b840eb50",
  null
  
)

export default component.exports